export default "__VITE_ASSET__DMCR3gpc__"